import { useGetHttp } from "../../../../hooks/http/http.hook";
import type { IPost } from "../../../../types/models/post.models.types";

interface IResponse {
  post: IPost;
}

export function useGetPostByIdHttp() {
  return useGetHttp<IResponse>({
    path: "/brand/posts/:postId",
  });
}
